<template>

  <v-select 
    multiple 
    :value="selected"
    @input="change"
    :options="membersOptions">
    </v-select>

</template>

<script>
export default {
  name: 'ApprovalruleFormApprovers',
  props: [
    'value',
    'members'
  ],
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
    selected () {
      return this.value.map((val) => {
        return {
          label: val.name,
          value: val
        }
      })
    },
    membersOptions () {
      return this.members.map((val) => {
        return {
          label: val.user_id.name,
          value: {
            user_id: val.user_id._id,
            email: val.user_id.email,
            name: val.user_id.name
          }
        }
      })
    }
  },
  created () {
  },
  methods: {
    change (selecteds) {
      const values = selecteds.map((val) => {
        return val.value
      })

      // quando input é definido, v-select redispara input
      // isso faz o controle para nao entrar em loop infinito
      if (JSON.stringify(values) !== JSON.stringify(this.value)) {
        this.$emit('input', values)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Approvalrule/ApprovalruleFormApprovers.vue